import { HoneycombTileShape } from '../types/honeycomb.js';
import { calculateHexSizeBasedOnHeight } from './shapes/hexagon/calculate-hex-size-based-on-width.js';

export const calculateTileWidth = (
  height: number,
  shape: HoneycombTileShape,
) => {
  return shape === 'hexagon'
    ? calculateHexSizeBasedOnHeight(height).width
    : height;
};
